import { render } from "./farming.vue?vue&type=template&id=4d94916e&scoped=true&ts=true"
import script from "./farming.vue?vue&type=script&lang=ts"
export * from "./farming.vue?vue&type=script&lang=ts"

import "./farming.vue?vue&type=style&index=0&id=4d94916e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d94916e"]])

export default __exports__